var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mobile-breadcrumb",attrs:{"justify":"center","align":"center"}},[_c('v-icon',{staticClass:"breadcrumb-back",attrs:{"medium":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("fas fa-chevron-left")]),_c('span',{staticClass:"text-subtitle-1 font-weight-bold"},[_vm._v(_vm._s(_vm.$t(_vm.title)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }